import {MiscI18n} from '@/locales/base.message.locales';

export const misc: MiscI18n = {
  days: 'days',
  hours: 'hours',
  minutes: 'min',
  seconds: 'sec',
};
